document.addEventListener('DOMContentLoaded', function () {
  // Hero slideshow
  var slides = document.querySelectorAll('.hero-slide');
  var dots = document.querySelectorAll('.hero-dot');
  var current = 0;
  if (slides.length > 1) {
    setInterval(function () {
      slides[current].classList.remove('is-active');
      dots[current] && dots[current].classList.remove('is-active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('is-active');
      dots[current] && dots[current].classList.add('is-active');
    }, 5000);
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        slides[current].classList.remove('is-active');
        dots[current].classList.remove('is-active');
        current = i;
        slides[current].classList.add('is-active');
        dots[current].classList.add('is-active');
      });
    });
  }

  // Mobile nav drawer
  var toggle = document.querySelector('.mobile-menu-toggle');
  var drawer = document.querySelector('.mobile-nav-drawer');
  var overlay = document.querySelector('.mobile-nav-overlay');
  function closeDrawer() {
    drawer && drawer.classList.remove('is-open');
    overlay && overlay.classList.remove('is-open');
  }
  toggle && toggle.addEventListener('click', function () {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
  });
  overlay && overlay.addEventListener('click', closeDrawer);

  // Order tracking form (points to Shopify order status page)
  var trackForm = document.querySelector('.tracking-form');
  if (trackForm) {
    trackForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var val = trackForm.querySelector('input').value.trim();
      if (val) {
        window.location.href = '/account/orders/' + encodeURIComponent(val);
      }
    });
  }
});
